import { KursyGeneralList } from "@/kursy/general";
import { Link } from "@tanstack/react-router";
import { CourseTitleCard } from "./CourseTitleCard";

export const CoursesGeneralList = (): JSX.Element => {
	return (
		<main className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto">
			<div className="flex flex-col gap-3">
				{KursyGeneralList.map((kurs) => (
					<Link key={kurs.slug} to={`/courses/${kurs.slug}`}>
						<CourseTitleCard kurs={kurs} />
					</Link>
				))}
			</div>
		</main>
	);
};
